import {
  SET_REASON_FILTERS,
  RESET_REASON_FILTERS,
  SET_REASON_GRID_SORT_CRITERIA,
} from './actionTypes';

export const setReasonFilters = filters => ({
  type: SET_REASON_FILTERS,
  filters,
});

export const cleanReasonFilters = () => ({
  type: RESET_REASON_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_REASON_GRID_SORT_CRITERIA,
  sortCriteria,
});
